import * as React from 'react';
import { PageProps } from "src/models/common/ComponentProps";
import bindAllOfThis from "src/utils/BindThisHelper";
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { ReduxStoreModel } from 'src/redux/ReduxModel';
import { Button } from 'antd';
import { updateUserCounter } from '../../redux/ExampleActions';

interface ReduxTestProps extends PageProps<{}> {
    count: number;
    addItems: (newCount: number) => void;
}

class ReduxTest extends React.Component<ReduxTestProps> {
    constructor(props: ReduxTestProps) {
        super(props);
        bindAllOfThis(this, ReduxTest.prototype);
    }

    render() {
        return (<div>
            <div>Hey you just made the ReduxTest component, woot!</div>
            <div>
                <span>Counter </span>
                <span>{this.props.count}</span>
            </div>
            <div>
                <Button type="primary" onClick={() => this.props.addItems(42)}>Increment</Button>
            </div>
        </div>);
    }
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
    return ({
        addItems: (newCount: number) => updateUserCounter(dispatch, newCount)
    });
}

function mapStateToProps(state: ReduxStoreModel) {
    return {
        count: state.User.cultureId
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ReduxTest);



// WEBPACK FOOTER //
// ./src/pages/examples/ReduxTest.tsx